import React from 'react'

import { FileDropContextValue } from './types'

export const FileDropContext = React.createContext<FileDropContextValue>({
  isDragging: false,
  files: []
})
